import { Route, Routes, Navigate } from 'react-router-dom';
import { Shell } from './ui/Shell.js';
import { SignInPage } from './pages/SignInPage.js';
import { VerifyEmailPage } from './pages/VerifyEmailPage.js';
import { PipelinePage } from './pages/PipelinePage.js';
import { CrmPage } from './pages/CrmPage.js';
import { ManaPricingPage } from './pages/mana-pricing/ManaPricingPage.js';
import { RealtorContactsPage } from './pages/mana-pricing/RealtorContactsPage.js';
import { WorkflowsPage } from './pages/WorkflowsPage.js';
import { IntegrationsPage } from './pages/IntegrationsPage.js';
import { AdminPage } from './pages/AdminPage.js';
import { PlaceholderPage } from './pages/PlaceholderPage.js';
import { useAuth } from './lib/auth-context.js';

export function App() {
  const { loading, me } = useAuth();

  if (loading) {
    return (
      <div className="flex h-full items-center justify-center text-slate-500">Loading…</div>
    );
  }

  if (!me) {
    return (
      <Routes>
        <Route path="/signin" element={<SignInPage />} />
        <Route path="/verify-email" element={<VerifyEmailPage />} />
        <Route path="*" element={<Navigate to="/signin" replace />} />
      </Routes>
    );
  }

  return (
    <Shell>
      <Routes>
        <Route path="/" element={<Navigate to="/pipeline" replace />} />
        <Route path="/pipeline" element={<PipelinePage />} />
        <Route path="/workflows/*" element={<WorkflowsPage />} />
        <Route path="/integrations" element={<IntegrationsPage />} />
        <Route path="/admin" element={<AdminPage />} />
        {/* Pricing and Other Lenders Pricing were retired on 2026-10-11 (Mana Pricing replaced both); old links land there. */}
        <Route path="/pricing" element={<Navigate to="/mana-pricing" replace />} />
        <Route path="/other-lenders-pricing" element={<Navigate to="/mana-pricing" replace />} />
        <Route path="/mana-pricing" element={<ManaPricingPage />} />
        <Route path="/mana-pricing/realtors" element={<RealtorContactsPage />} />
        <Route path="/accounting" element={<PlaceholderPage moduleKey="accounting" />} />
        <Route path="/call-reports" element={<PlaceholderPage moduleKey="call_reports" />} />
        <Route path="/reporting" element={<PlaceholderPage moduleKey="reporting" />} />
        <Route path="/crm" element={<CrmPage />} />
        <Route path="/admin-tasks" element={<PlaceholderPage moduleKey="admin_tasks" />} />
        <Route path="*" element={<Navigate to="/pipeline" replace />} />
      </Routes>
    </Shell>
  );
}
